import React from 'react';
import PropTypes from 'prop-types';

import { CopyableText } from 'modules/Common/Copy';

const IdCell = ({ id, idType = 'J', className }) => (
  <CopyableText text={`${idType}${id}`} className={className} />
);

IdCell.propTypes = {
  id: PropTypes.number,
  className: PropTypes.string,
  idType: PropTypes.string,
};

export default IdCell;
